<!-- @format -->

@if (validatablePlan) {
  @if (selectedModule) {
    <span>
      {{ selectedModule.name | localizedString }}
      {{ selectedModule.code ? " - " + selectedModule.code : "" }}
    </span>
  }
  <button type="button" class="link-button" (click)="openPlanSelector()">
    {{ (selectedModule ? "CHANGE" : "PROFILE.APPLICATIONS.SELECT_LOCATION") | translate }}
  </button>
}
